import { loadCommentUsers } from './comments.config'
import { useEffect, useState } from 'react'

// Every author resolves out of one memoised directory fetch, so a surface can wait for that fetch
// instead of letting each avatar resolve — and flash — on its own.
export const useCommentUsersReady = (): boolean => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    let active = true
    // Ready on failure too, otherwise a transient listUsers error holds the surface on its skeleton.
    loadCommentUsers().finally(() => {
      if (active) setIsReady(true)
    })
    return () => {
      active = false
    }
  }, [])

  return isReady
}
